<template>
  <AttrBase
    v-slot="{ hover }"
    :label="label"
    :content-flex="1.8"
    :disabled="disabled"
    :tooltip="tooltip"
  >
    <div
      v-if="showTooltip"
      class="w-[16px] h-[16px] bg-[#B6B6B6] rounded-[50%] text-[#000000] flex justify-center items-center absolute right-[195px]"
      @click="!disabled && showModal()"
    >
      ?
    </div>
    <div
      :class="{
        ' opacity-30': disabled
      }"
    >
      <div class="flex items-center justify-between">
        <div class="bg-transparent pr-1 pb-1">
          <icon
            :icon="label == '上传js文件夹' ? 'fileDir.svg' : 'fileDir2.svg'"
            :width="20"
            :height="20"
            fill="transparent"
            @click="() => !disabled && emits('upload')"
          />
        </div>
        <div class="flex" :class="{ 'border-b-[1px]': dirname }">
          <div
            class="border-0 h-[21px] relative max-w-24 truncate ml-[2px]"
            :class="{ 'w-20': !dirname }"
            @click="() => !disabled && emits('upload')"
          >
            <span v-if="dirname"> {{ dirname }}</span>
            <span v-else class="opacity-[0.3]">选择文件夹</span>
          </div>
          <div v-if="dirname" @click="() => !disabled && emits('upload')">
            {{ dirnameSuffix }}
          </div>
          <!-- 删除icon -->
          <div
            v-if="dirname && hover && !disabled"
            class="absolute -top-[7px] right-[0px]"
            @click.stop="() => !disabled && emits('delete')"
          >
            <icon icon="delete.svg" :width="10" :height="10" fill="none" />
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model:visible="visible" title="提示">
      <img :src="jsImg" alt="" />
      <template #footer>
        <a-button type="primary" @click="handleok"> 知道了 </a-button>
      </template>
    </a-modal>
  </AttrBase>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import jsImg from '@/assets/img/jsImg.png';
defineProps({
  label: {
    type: String,
    default: '上传文件夹'
  },
  dirname: {
    type: String,
    default: undefined
  },
  disabled: {
    type: Boolean,
    default: false
  },
  showTooltip: {
    type: Boolean,
    default: false
  },
  dirnameSuffix: {
    type: String,
    default: '.文件夹'
  },
  tooltip: {
    type: String,
    default: ''
  }
});
const emits = defineEmits<{
  (event: 'upload'): void;
  (event: 'delete'): void;
}>();
const visible = ref<boolean>(false);
const showModal = () => {
  visible.value = true;
};
const handleok = () => {
  visible.value = false;
};
</script>

<style lang="less" scoped></style>
